import { Validation, ValidationStatus, IFormItem, IBlock, ValidationFn } from "./types";

export function getFormItemCss(item, validate?: boolean) {
	const {
		labelInline,
		required,
		disabled,
		hiddenLabel,
		css,
		$validationStatus,
	} = item;
	const cssStatus = {
		[ValidationStatus.pre]: "",
		[ValidationStatus.error]: " dhx_form-group--state_error",
		[ValidationStatus.success]: " dhx_form-group--state_success",
	}[$validationStatus] || "";
	const labelPositionCss = labelInline ? " dhx_form-group--inline" : "";
	const requiredCss = required ? " dhx_form-group--required" : "";
	const disabledCss = disabled ? " dhx_form-group--disabled" : "";
	const labelSrCss = hiddenLabel ? " dhx_form-group--label_sr" : "";
	if (validate) {
		return (
			css || "" +
			labelPositionCss +
			cssStatus +
			requiredCss +
			disabledCss +
			labelSrCss
		);
	}
	return (
		css || "" +
		labelPositionCss +
		disabledCss +
		labelSrCss
	);
}

const validators: {[key: string]: RegExp} = {
	[Validation.validAplhaNumeric]: /^[a-zA-Z0-9_]+$/,
	[Validation.validEmail]: /^.+@.+\..+$/,
	[Validation.validInteger]: /^\d+$/,
	[Validation.validIPv4]: /\b((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|$)){4}\b/,
	[Validation.validNumeric]: /^\d+(\.\d+)?$/
};

export function getValidationMessage(item) {
	const validationMessage = {
		undefined: item.preMessage,
		[ValidationStatus.pre]: item.preMessage,
		[ValidationStatus.error]: item.errorMessage,
		[ValidationStatus.success]: item.successMessage,
	}[item.$validationStatus] || "";
	return validationMessage;
}

export function validateTemplate(template: Validation, str) {
	return validators[template] ? validators[template].test(str) : true;
}

export function isBlock(config: IFormItem): config is IBlock {
	return Boolean((config as IBlock).rows) || Boolean((config as IBlock).cols);
}

export function validateInput(value: string, validation: Validation | ValidationFn): boolean {
	let isValid = true;
	if (typeof validation === "function") {
		isValid = validation(value);
	} else {
		const regExp = validators[validation];
		if (regExp) {
			isValid = regExp.test(value);
		}
	}

	return isValid;
}

export function isTimeFormat(value: string, timeFormat?: number): boolean {
	if (timeFormat === 12) {
		return /(^0?([1-9][0-2]?):[0-5][0-9]?([AP][M]?)$)/i.test(value);
	}
	return /(^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$)/i.test(value);
}

export const isEmptyObj = obj => {
	for (const key in obj) {
		return false;
	}
	return true;
};